var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4585_6844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36533 0.319866C3.58287 -0.11261 2.66417 -0.10261 1.88672 0.326115L10.9987 8.73189L14.0598 5.67081L4.36533 0.319866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.975468 1.18607C0.752981 1.5498 0.625488 1.96602 0.625488 2.40725V17.5889C0.625488 18.0164 0.741732 18.4238 0.95172 18.7801L10.115 9.61684L0.975468 1.18607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1183 7.91069L15.1984 6.29953L11.9174 9.57934L15.9384 13.2879L18.1195 12.0842C18.9045 11.6492 19.3744 10.8693 19.3744 9.99682C19.3732 9.12437 18.9045 8.34441 18.1183 7.91069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0337 10.4643L1.84546 19.6525C2.24419 19.88 2.68166 20 3.12164 20C3.54661 20 3.97409 19.8925 4.36532 19.6763L14.786 13.9253L11.0337 10.4643Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4585_6844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.2e596828e67ded7269eb11790a228f84.svg";
export { ForwardRef as ReactComponent };